import { Injectable } from '@angular/core';
import { NativeStorageNamesV2 } from '../../models/Constants';
import { StorageData } from '../../services/utilities/storage-data.class';

@Injectable({
  providedIn: 'root'
})
export class UserAnalyticsService {
  constructor() { }

  /**
   * Recupera y mapea el perfil del usuario activo al formato unificado de analíticas global.
   */
  public async getUserProfileProperties(): Promise<Record<string, any>> {
    const userData = await StorageData.getDataStorage(NativeStorageNamesV2.PerfilUsuario);
    if (!userData) return {};

    return {
      user_id: String(userData.usr_idTendero || ''),
      usr_id: `${userData.usr_bodega || ''}|${userData.usr_nud || ''}`,
      usr_bodega: String(userData.usr_bodega || ''),
      usr_nud: String(userData.usr_nud || ''),
      usr_canal: userData.usr_canal || 'sin_canal',
      usr_edad: String(userData.usr_edad || ''),
      usr_genero: userData.usr_genero || 'no especificar',
      usr_nivel: userData.usr_nivel || 'sin_nivel',
      usr_programa: userData.usr_programa || 'sin programa',
      usr_region: userData.usr_region || '',
      usr_ruta: String(userData.usr_ruta || ''),
      usr_negocio: userData.usr_negocio || '',
      usr_territorio: userData.usr_territorio || '',
      usr_tipo: userData.usr_tipo || 'tendero'
    };
  }
}
